var _path, _line, _path2, _line2, _line3, _line4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoom2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 198,
    height: 163,
    viewBox: "0 0 198 163",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M186.122 34.4844V97.5146L128 129.153L69.8779 97.5146V34.4844L128 2.8457L186.122 34.4844Z",
    fill: "#1A1A1A",
    stroke: "white",
    strokeWidth: 5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: -2.5,
    x2: 66.5403,
    y2: -2.5,
    transform: "matrix(-0.885657 0.46434 -0.509215 -0.860639 185.318 33.2343)",
    stroke: "white",
    strokeWidth: 5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M128.122 65.4844V128.515L70 160.153L11.8779 128.515V65.4844L70 33.8457L128.122 65.4844Z",
    fill: "#1A1A1A",
    stroke: "white",
    strokeWidth: 5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: -2.5,
    x2: 66.8693,
    y2: -2.5,
    transform: "matrix(0.8813 0.472557 -0.517712 0.855555 10.4437 66.0946)",
    stroke: "white",
    strokeWidth: 5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 71.5,
    y1: 97,
    x2: 71.5,
    y2: 160,
    stroke: "white",
    strokeWidth: 5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    y1: -2.5,
    x2: 66.5403,
    y2: -2.5,
    transform: "matrix(-0.885657 0.46434 -0.509215 -0.860639 127.561 63.988)",
    stroke: "white",
    strokeWidth: 5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoom2);
export default __webpack_public_path__ + "static/media/room2.b54717aff99a00cfa253935c0329a69f.svg";
export { ForwardRef as ReactComponent };